import { useSelector } from 'react-redux';

import { getIsPending } from '../selectors/ui';

export const useIsPending = (type: string | Array<string>): boolean =>
  useSelector(getIsPending(type));
